import styled, { css } from "styled-components";

export const Spacing = styled.div`
  ${props =>
    props.top &&
    css`
      margin-top: ${props.top}rem;
    `};
  ${props =>
    props.bottom &&
    css`
      margin-bottom: ${props.bottom}rem;
    `};
  ${props =>
    props.left &&
    css`
      margin-left: ${props.left}rem;
    `};
  ${props =>
    props.right &&
    css`
      margin-right: ${props.right}rem;
    `};

  ${props =>
    props.horizonatal &&
    css`
      margin-right: ${props.horizonatal}rem;
      margin-left: ${props.horizonatal}rem;
    `};

  ${props =>
    props.vertical &&
    css`
      margin-top: ${props.vertical}rem;
      margin-bottom: ${props.vertical}rem;
    `};
`;

//remove size, switch to coll
export const Cell = styled.div`
  box-sizing: inherit;
  flex-basis: 100%; /* 1 */
  min-width: ${props => (props.minWidth ? props.minWidth : 0)}; /* 2 */
  ${props => props.maxWidth && `max-width:${props.maxWidth}`}; /* 2 */
  padding: 0 calc(0.5 * 1rem);
  ${props => props.spacing && `padding-bottom: ${props.spacing}rem`};
  ${props => props.size && sizeCell(props.size)};
  ${props => props.fit && "flex-basis: auto;"};
  ${props => props.fill && fillCell()};
  ${props => props.col && sizeCell(props.col)};
  @media (min-width: 320px) and (max-width: 768px) {
    ${props => props.smCol && sizeCell(props.smCol)};
    ${props => props.smFill && fillCell()};
    ${props => props.smFit && "flex-basis: auto;"};
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    ${props => props.mdCol && sizeCell(props.mdCol)};
    ${props => props.mdFill && fillCell()};
    ${props => props.mdFit && "flex-basis: auto;"};
  }
  @media (min-width: 1025px) {
    ${props => props.lgCol && sizeCell(props.lgCol)};
    ${props => props.lgFill && fillCell()};
    ${props => props.lgFit && "flex-basis: auto;"};
  }
  @media (min-width: 1360px) {
    ${props => props.xlgCol && sizeCell(props.xlgCol)};
    ${props => props.xlgFill && fillCell()};
    ${props => props.xlgFit && "flex-basis: auto;"};
  }
`;
Cell.li = Cell.withComponent("li");

export const Grid = Spacing.extend`
  box-sizing: border-box;
  display: flex;
  flex-flow: ${props => (props.noWrap ? "row" : "row wrap")};
  padding: 0;
  margin: 0 calc(-0.5 * 15px);
  ${props =>
    props.noGutter &&
    css`
      margin: 0;
      > ${Cell} {
        padding: 0;
      }
    `};

  ${props => props.middle && "align-items: center;"};
  ${props => props.bottom && "lign-items: flex-end;"};

  > * {
    ${props => props.fill && "flex: 1 1 0%;"};
    ${props => props.fit && "flex-basis: auto;"};
  }

  @media (min-width: 320px) and (max-width: 768px) {
    > * {
      ${props => props.smFill && "flex: 1 1 0%;"};
      ${props => props.smFit && "flex-basis: auto;"};
    }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    > * {
      ${props => props.mdFill && "flex: 1 1 0%;"};
      ${props => props.mdFit && "flex-basis: auto;"};
    }
  }
  @media (min-width: 1025px) {
    > * {
      ${props => props.lgFill && "flex: 1 1 0%;"};
      ${props => props.lgFit && "flex-basis: auto;"};
    }
  }
`;
Grid.ul = Grid.extend`
  list-style-type: none;
`.withComponent("ul");

function fillCell() {
  return css`
    flex: 1 1 0% !important; /* 1 */
    flex-basis: 0% !important; /* 2 */
  `;
}

function sizeCell(size) {
  return {
    flexBasis: "auto !important",
    width: `${size / 12 * 100}%`
  };
}

export const CenteredContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
// {
//   // we can define static props
//   type: "password",

//   // or we can define dynamic ones
//   margin: props => props.size || "1em",
//   padding: props => props.size || "1em"
// }

export const Box = styled.div`
  display: flex;
  height: 100%;

  ${props => props.middle && "align-items: center;"};
  ${props => props.center && "justify-content: center;"};
  ${props => props.bottom && "align-items: flex-end;"};
  ${props => props.right && "justify-content: flex-end;"};
`;

export const BoxStock = styled.div`
  display: flex;
  ${props => props.middle && "align-items: center;"};
  ${props => props.center && "justify-content: center;"};
  ${props => props.bottom && "align-items: flex-end;"};
  ${props => props.right && "justify-content: flex-end;"};
`;

export const Border = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
  height: 100%;
`;
